import { Slide } from "@jelly/lesson";
import config from "appConfig";
import variables from "../../../../../../assets/styles/sass-resources.scss";

import { task as task01 } from "../../../../../task/course-03/lesson-02/task-01";

const task: Slide = {
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 2,
      colSpan: {
        "1:0": 2,
      },
      colsSize: [2.5, 1],
      rowsSize: [1, 3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "A source (in red) is located at  position (0 m, 34 m ) and a receiver (in blue) at position (2 m, 28m).<br>A horizontal  rigid boundary is associated to coordinate y=0. Speed of sound is 340m/s.<br>Choose the correct source -receiver impulse response among the four  following choices.",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    textAlign: "center",
                    color: variables["text-secondary"],
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/02/task/task-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
